import { useContext, useEffect } from "react";
import { AppContext } from "../App";

export const ProgressBar = () => {
	const { data, route, progressData, updateProgress } =
		useContext(AppContext);

	const stepProgress = {
		bookingForm: 0,
		intro: 0,
		loader: 0,
		thankYouPage: 0,
		contactForm: 0,
		errorPage: 0,
		damageGlass: 30,
		damageType: 40,
		damageArea: 50,
		damageGlassMoreInfo: 50,
		selectCenter: 70,
		selectDateTime: 80,
		bookingEnd: 90,
	};

	const progress =
		data?.reselectingCenter && route === "selectCenter"
			? stepProgress.selectDateTime
			: (stepProgress[route] ?? 0);

	const noProgressRoutes = [
		"bookingForm",
		"intro",
		"loader",
		"thankYouPage",
		"contactForm",
		"errorPage",
	];
	const shouldShow = !noProgressRoutes.includes(route);

	useEffect(() => {
		updateProgress(progress);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [route]);

	return (
		<div className={`progress_bar ${shouldShow ? "visible" : ""}`}>
			<div
				className={`progress_bar_fill ${progressData.isAnimating ? "animate" : ""}`}
				style={{
					width: `${progressData.progress}%`,
					"--start-width": `${progressData.prevProgress}%`,
					"--target-width": `${progressData.progress}%`,
				}}
			/>
		</div>
	);
};
